"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoOpenTip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _dsIcons = require("@olxbr/ds-icons");
var _propTypes = require("prop-types");
var _lurker = _interopRequireDefault(require("../../../helpers/lurker"));
var _TipBox = _interopRequireDefault(require("../TipBox"));
var _selectors = require("../../../selectors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var AutoOpenTip = exports.AutoOpenTip = function AutoOpenTip(_ref) {
  var partner = _ref.partner,
    listId = _ref.listId;
  var sellerId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getSellerId)(state);
  });
  var buyerId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getBuyerId)(state);
  });
  var amISeller = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.amISeller)(state);
  });
  (0, _react.useEffect)(function () {
    var type = partner.online ? 'tip_incentive_online' : 'tip_incentive_offline';
    _lurker["default"].viewTipEvent(type, {
      idMessage: '',
      listId: listId,
      sellerId: sellerId,
      buyerId: buyerId,
      amISeller: amISeller
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      icon: partner.online ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Check, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Info, {}),
      cta: null,
      text: partner.online ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: partner.name
        }), ' está online agora! Tire suas dúvidas sobre este produto diretamente com o vendedor!']
      }) : 'Se interessou neste anúncio? Envie uma mensagem para o vendedor para tirar dúvidas sobre o produto!'
    },
    variant: partner.online ? 'success' : 'default'
  });
};
AutoOpenTip.propTypes = {
  partner: _propTypes.object,
  listId: _propTypes.string
};